import { render, staticRenderFns } from "./UpsellPopup.vue?vue&type=template&id=f3dda8de"
import script from "./UpsellPopup.vue?vue&type=script&lang=js"
export * from "./UpsellPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports